export type SvgIconProps = {
  fill: string;
  width: number;
  height: number;
  className?: string;
  ariaLabel?: string;
  ariaHidden?: boolean;
};

export const ICON_TYPES = [
  'accessibility',
  'accessibility-2',
  'accessibility-3',
  'family',
  'adult',
  'education',
  'member',
  'member-2',
  'zsl-200',
  'calendar-check',
  'calendar',
  'location',
  'clock',
  'ticket',
] as const;

export type IconType = (typeof ICON_TYPES)[number];

export type IconProps = {
  type: IconType;
  width?: number;
  height?: number;
  color?: string;
  useCurrentColor?: boolean;
  className?: string;
  ariaLabel?: string;
  ariaHidden?: boolean;
};
